import OmegaTracker from '@didi/omega-tracker'

const IS_DEV:boolean = (/^localhost|(\d+.){3}\d+/.test(window ? window.location.hostname : ''))
interface omegaInstance {
  trackEvent: any
}
export const Omega: omegaInstance = IS_DEV ? {
  trackEvent () { console.log('daphneSDK：测试环境屏蔽埋点') }
} : OmegaTracker.getTracker({
  appKey: 'omega3323f005b6',
  autoPosition: false,
  uploadHost: 'omgup.didiglobal.com',
  browserRouterEnable: false,
  autoClick: false,
  autoError: false,
  autoSendPageView: false,
  disabledInit: false,
  attrs: {
    // 设备和业务信息 http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=272905834
    osType: -1,
    businessType: 5, // 内部业务类型 1:r, 2:c, 3:b, 4:bd, 5:m
    brand: 2, // 外卖品牌类型 1:滴滴外卖，2:didi Food，3:99 Food
    terminalType: 5 // 端类型信息 1：独立端 5：web
  }
})
